const navigationEn = {
	USER: 'User',
	USER_LIST: 'Access',
	DASHBOARD_ROLE: 'Role',
	TECH: 'Tech',
	MEASUREMENT_UNIT: 'Measurement Unit',
	WHATIF: 'What if',
	OPTIMIZATIONPIPELINE: 'Optimization Pipeline',
	OPTIMIZATIONPIPELINEV2: 'Optimization Pipeline V2',
	WHATIFRUN: 'Run',
	WHATIFEXPERT: 'What if',
	WHATIFGROUP: 'What if group',
	DRIVER: 'Driver',
	DRIVERLOG: 'Driver Log',
	EXPERT: 'Expert',
	OPTIMIZERLOG: 'Optimizer Log',
	DATASET: 'Dataset',
	MODEL: 'Model',
	OPTIMIZATIONCASE: 'Optimization Case',
	OBJECTIVE: 'Objective',
	ASPECT: 'Aspect',
	OPERATOR: 'Operator',
	WORKFLOW: 'Workflow',
	FITTINGCASE: 'Fitting Case',
	TASKMANAGER: 'Task Manager',
	FITTERLOG: 'Fitter Log',
	PICTOGRAM: 'Pictogram',
	PI_MEASUREMENT_READER: 'PI Measurement Reader',
	PI_AF_EVENT_READER: 'PI AF Event Reader',
	LAB_CONNECTION: 'Lab Connection',
	PI_CONNECTION: 'PI Connection',
	LAB_MEASUREMENT_READER: 'Lab Measurement Reader',
	TRANSFORMER: 'Transformer',
	MEASUREMENT: 'Measurement',
	SCHEDULER: 'Scheduler',
	OPTIMIZER: 'Optimizer',
	OUTLIERDETECTOR: 'Outlier Detector',
	UNITOPTIMIZER: 'Unit Optimizer',
	MODELVALIDATIONLOG: 'Model Validation Log',
	MODELVALIDATION: 'Model Validation',
	UNITOPTIMIZERLOG: 'Unit Optimizer Log',
	NOTIFICATION: 'Notification',
	OPTIMIZATIONPIPELINELOG: 'Optimization Pipeline Log',
	UNITOPTIMIZEROVERVIEW: 'Unit Optimizer Overview',
	SIMULATIONMONITOR: 'Simulation Monitor',
	SIMULATIONMONITORLOG: 'Simulation Monitor Log',
	USER_GROUP: 'User Group',
	PI_WRITER: 'PI Writer',
	PI_WRITER_LOG: 'PI Writer Log',
	EDTDYNAMICCHECK: 'EDT Dynamic Check',
	EDTDYNAMICCHECKLOG: 'EDT Dynamic Check Log',
	OPC_DA_WRITER: 'OPC DA Writer',
	OPC_DA_WRITER_LOG: 'OPC DA Writer Log'
};

export default navigationEn;
